import React from 'react';
import {Button} from 'app/components/sharedReactComponents/Button';
import {THEME, VARIANT} from 'app/constants';
import {Icons} from 'app/util/icons';
import {router} from 'app/router/main';
import {useCloud} from 'app/components/features/cloud';

export function AddPaymentMethodMessage() {
  const {team, user} = useCloud();

  if (!user.role.canEditBilling() || team.caps.transcribing.enabled) {
    return null;
  }

  if (team.caps.transcribing.reason === 'subscription_is_dq') {
    return null;
  }

  return (
    <div className="add-payment-method-message">
      <Button
        className="add-payment-method-message__button"
        theme={THEME.DANGER}
        variant={VARIANT.TEXT}
        onClick={() => router.go('settingBillingUsage')}
      >
        {Icons.addPaymentMethod()
          .label('Add a payment method')
          .class('add-payment-method-message__icon')
          .reactComponent()}
      </Button>

      {' to enable transcription'}
    </div>
  );
}
